// extracted by mini-css-extract-plugin
export default {"select":"TmoSelect_select__-+jbM"};